// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"a28af603","544":"5f9a3552","584":"69892d0b","600":"e88e7823"}[chunkId] + ".chunk.js";
};